<ion-button (click)="openMenu()">
  <ion-img src="assets/menuIcon/newicon.png"> </ion-img>
</ion-button>
